import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { useLanguage } from "../../LanguageProvider";
import "../../styles/components/modal.css";

export const SelectionModal = ({ 
  isOpen, 
  onClose, 
  title, 
  options, // Array of { value, label, icon, active }
  onSelect 
}) => {
  const { t } = useLanguage();
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="modal-overlay-wrapper selection-modal-wrapper bottom-sheet">
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="modal-backdrop"
            onClick={onClose}
          />
          <div className="modal-container">
            <motion.div 
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 20 }}
              transition={{ type: "spring", damping: 25, stiffness: 300 }}
              className="confirm-modal selection-modal"
            >
              <button className="modal-close-btn" onClick={onClose}>
                <X size={20} />
              </button>
              
              <div className="modal-content-area" style={{ marginBottom: '1.5rem', width: '100%' }}>
                <h2 className="modal-title" style={{ textAlign: 'center' }}>{title}</h2>
              </div>
              
              <div className="selection-list">
                {options.map((option) => (
                  <button 
                    key={option.value}
                    className={`selection-item ${option.active ? 'active' : ''}`}
                    onClick={() => {
                      onSelect(option.value);
                      onClose();
                    }}
                  >
                    {option.icon && <span className="selection-icon">{option.icon}</span>}
                    <span className="selection-label">{option.label}</span>
                    {option.active && <div className="active-dot" />}
                  </button>
                ))}
              </div>

              <div className="modal-actions-horizontal" style={{ marginTop: '1rem' }}>
                <button 
                  className="modal-btn-secondary" 
                  onClick={onClose}
                  style={{ width: '100%' }}
                >
                  {t("close")}
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      )}
    </AnimatePresence>
  );
};
